import React from 'react';
import { PropTypes } from 'prop-types';

import Dropzone from './dropzone.jsx';
import { observer } from 'mobx-react';
import { uploadStore } from '../../core/stores/upload.store';
import { utilsService } from '../../core/services/utils.service';


@observer
export default class ImageDropzone extends React.Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    saveRef: PropTypes.func,
    disabled: PropTypes.bool,
    existingFile: PropTypes.object,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    helperText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    type: PropTypes.string,
    allowedExtensions: PropTypes.array,
    contentType: PropTypes.string,
    onChange: PropTypes.func
  }

  static defaultProps = {
    saveRef: () => { },
    disabled: false,
    existingFile: { imageUrl: '' },
    isRequired: true,
    onChange: () => {}
  }

  constructor(props) {
    super(props);
    this.references = {};
    this.fileMetaObject = uploadStore.registerDropzone({
      id: this.props.id,
      allowedExtensions: this.props.allowedExtensions,
      contentType: this.props.contentType,
      imageUrl: this.props.existingFile.imageUrl,
      uploadDate: this.props.existingFile.uploadDate
    });
  }

  handleRemoveFile = () => {
    uploadStore.handleRemoveFile(this.props.id);
    this.props.onChange(null);
  }

  render() {
    let imageIsUploaded = (this.fileMetaObject && Boolean(this.fileMetaObject.imageUrl))
    return (
      <div className="screenshot-dropzone-section">
        <Dropzone
          {...this.props}
          hideDropArea={imageIsUploaded}
          isImageUpload />
        {imageIsUploaded &&
          <div className="app-icon visible">
            <img alt="appIcon" className={`icon-image ${(this.fileMetaObject.isUploading)
              ? 'uploading'
              : ''}`} src={utilsService.getFilePath(this.fileMetaObject.imageUrl)} />
            {this.fileMetaObject.isUploading && <div className="progress loading-indicator">
              <div className="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow={this.fileMetaObject.progress} aria-valuemin="0" aria-valuemax="100" style={{
                width: `${this.fileMetaObject.progress}%`
              }}>
                <span className="sr-only">{`${this.fileMetaObject.progress}% Complete`}</span>
              </div>
            </div>}
            <button ref={(i) => this.references['appIconDeleteButton'] = i} className="btn fn-hi-contrast delete-button" onClick={this.handleRemoveFile} disabled={this.props.disabled} type="button">
              <span className="sr-only">Remove app icon</span>
              <span className="icon-trash white"></span>
            </button>
          </div>
        }
      </div>
    )
  }
}
